/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiMemberDtoCreateExcelFromMembersDto
 */
export interface WebApiMemberDtoCreateExcelFromMembersDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof WebApiMemberDtoCreateExcelFromMembersDto
     */
    filteredMemberIds?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiMemberDtoCreateExcelFromMembersDto
     */
    includeCustomLists?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiMemberDtoCreateExcelFromMembersDto
     */
    includeNotes?: boolean;
}

/**
 * Check if a given object implements the WebApiMemberDtoCreateExcelFromMembersDto interface.
 */
export function instanceOfWebApiMemberDtoCreateExcelFromMembersDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiMemberDtoCreateExcelFromMembersDtoFromJSON(json: any): WebApiMemberDtoCreateExcelFromMembersDto {
    return WebApiMemberDtoCreateExcelFromMembersDtoFromJSONTyped(json, false);
}

export function WebApiMemberDtoCreateExcelFromMembersDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiMemberDtoCreateExcelFromMembersDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'filteredMemberIds': !exists(json, 'filteredMemberIds') ? undefined : json['filteredMemberIds'],
        'includeCustomLists': !exists(json, 'includeCustomLists') ? undefined : json['includeCustomLists'],
        'includeNotes': !exists(json, 'includeNotes') ? undefined : json['includeNotes'],
    };
}

export function WebApiMemberDtoCreateExcelFromMembersDtoToJSON(value?: WebApiMemberDtoCreateExcelFromMembersDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'filteredMemberIds': value.filteredMemberIds,
        'includeCustomLists': value.includeCustomLists,
        'includeNotes': value.includeNotes,
    };
}

